import React from "react";
import Marquee from "react-fast-marquee";

export default function ImgOne() {
  return (
    <div>
      <div className="tp-brand-3-area pb-120">
        <div className="container container-1400">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-brand-3-slider-wrapper">
                <div className="swiper-container tp-brand-3-slider-active fix">
                  <div className="swiper-wrapper brand-wrapper">
                    <Marquee>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-1.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-2.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-3.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-4.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-5.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-7.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-6.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-2.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-1.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-2.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-3.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-4.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-5.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-7.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-6.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div className="swiper-slide ps-5">
                        <div className="tp-brand-item">
                          <img
                            src="assets/img/home-01/brand/brand-2.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </Marquee>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
